export default {
  CONFIRM_DELETION_ALL: '确认删除全部搜索记录?',
  HOT_SEARCH: '热门搜索',
  RECENTLY_SEARCH: '最近搜索',
  NO_RECENT_SEARCH: '暂无最近搜索',
  RECENT_SEARCH: '搜索'
};
